var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvatar3New = function SvgAvatar3New(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "auto",
    viewBox: "0 0 59 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avatar3New_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.866 36.142a4.124 4.124 0 0 1-4.125 4.125 4.124 4.124 0 0 1-4.125-4.125 4.124 4.124 0 0 1 4.125-4.125 4.124 4.124 0 0 1 4.125 4.125ZM5.74 48.33c0-.535.262-1.059.825-1.578.567-.524 1.39-.99 2.36-1.379 1.94-.777 4.283-1.168 5.816-1.168 1.533 0 3.876.39 5.817 1.168.97.389 1.792.855 2.36 1.38.562.518.824 1.042.824 1.578v1.687H5.74V48.33Z",
    stroke: "#53B741",
    strokeWidth: 1.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avatar3New_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.118 36.142a4.124 4.124 0 0 1-4.125 4.125 4.124 4.124 0 0 1-4.125-4.125 4.124 4.124 0 0 1 4.125-4.125 4.124 4.124 0 0 1 4.125 4.125ZM34.992 48.33c0-.535.262-1.059.825-1.578.567-.524 1.39-.99 2.36-1.379 1.94-.777 4.283-1.168 5.816-1.168 1.533 0 3.876.39 5.817 1.168.97.389 1.792.855 2.36 1.38.562.518.824 1.042.824 1.578v1.687H34.992V48.33Z",
    stroke: "#53B741",
    strokeWidth: 1.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avatar3New_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.492 10.545a4.124 4.124 0 0 1-4.125 4.126 4.124 4.124 0 0 1-4.125-4.126 4.124 4.124 0 0 1 4.125-4.125 4.124 4.124 0 0 1 4.125 4.125ZM20.366 22.734c0-.535.262-1.06.825-1.579.567-.524 1.39-.99 2.36-1.379 1.94-.777 4.283-1.168 5.816-1.168 1.533 0 3.876.391 5.817 1.168.97.389 1.792.855 2.36 1.38.562.519.824 1.043.824 1.578v1.688H20.366v-1.688Z",
    stroke: "#53B741",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "avatar3New_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.115 26.391)",
    d: "M0 0h29.252v29.252H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "avatar3New_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(29.367 26.391)",
    d: "M0 0h29.252v29.252H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "avatar3New_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(14.741 .794)",
    d: "M0 0h29.252v29.252H0z"
  })))));
};
export default SvgAvatar3New;